import { type ErrorInfo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import Providers from '@/providers';
import RouterProvider from '@/providers/RouterProvider';
import { Fallback } from './pages/Fallback';
import './App.css';

function logError(error: Error, info: ErrorInfo) {
  console.error('Caught an error:', error, info);
}

function App() {
  return (
    <ErrorBoundary FallbackComponent={Fallback} onError={logError}>
      <Providers>
        <RouterProvider />
      </Providers>
    </ErrorBoundary>
  );
}

export default App;
